export const classes = {
  grid: 'grid w-full h-full gap-3 overflow-hidden',
  single: 'grid-cols-1 grid-rows-1',
  twoUp: 'grid-cols-2 grid-rows-1',
  fourUp: 'grid-cols-2 grid-rows-2',
};

export function pickLayoutClass(count: number) {
  if (count <= 1) return classes.single;
  if (count === 2) return classes.twoUp;
  return classes.fourUp;
}
